import { useEffect } from 'react';

import { getWLID } from '../../../../weborder/Utilities';
import { Campaign } from '../../../api/restaurant/restaurant.types';
import { LoyaltyCampaigns } from '../../../state/restaurant/restaurant.types';

interface UseLoyaltyCampaigns {
  data: Campaign[];
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useLoyaltyCampaigns = (
  loadCampaignProgress: (appId: string, prId: number) => void,
  prId: number,
  isEnabled: boolean,
  loyaltyCampaigns: LoyaltyCampaigns = {},
): UseLoyaltyCampaigns => {
  const loyaltyCampaignsForRestaurant = loyaltyCampaigns[prId];

  const isLoading =
    (!loyaltyCampaignsForRestaurant ||
      loyaltyCampaignsForRestaurant.status === 'pending') &&
    isEnabled;

  const isSuccess = loyaltyCampaignsForRestaurant?.status === 'success';
  const isError = loyaltyCampaignsForRestaurant?.status === 'none';

  useEffect(() => {
    if (isLoading && prId) {
      loadCampaignProgress(getWLID(), prId);
    }
  }, [isLoading, prId]);

  const data = isSuccess ? loyaltyCampaignsForRestaurant.data : [];

  return {
    data,
    isError,
    isLoading,
    isSuccess,
  };
};
